import { useContext } from 'react';
import { FileContext } from '../context/file';

export const useFile = () => useContext(FileContext);
